import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useCallback, useEffect, useState } from 'react'

import { Course } from '@/domain/entities/course.entity'
import { ICourseService } from '../../services/contracts/courses'
import { useFormatOptions } from '../../hooks/use-format-options'
import { Institution } from '@/domain/entities/institution.entity'

type ListACoursesProps = {
  courseService: ICourseService
}

export function useListCourses({ courseService }: ListACoursesProps) {
  const { formatOptions } = useFormatOptions()
  const { id: studentId } = useParams()
  const [courses, setCourses] = useState<Course[]>([])

  const { data: dataCourses, isLoading: isLoadingCourses } = useQuery({
    queryKey: ['list_courses'],
    initialData: [{ courses: [] }, null],
    queryFn: courseService.loadAll,
  })

  const filterCoursesByInstitution = useCallback(
    (id: number) => {
      const [data] = dataCourses
      const coursesFiltered =
        data?.courses?.filter((course) => course.institution_id === id) || []
      setCourses(coursesFiltered)
    },
    [dataCourses],
  )

  const { data: coursesResponse } = useQuery({
    queryKey: ['list_course_by_student_id'],
    initialData: [
      {
        data: {
          courses: {} as Course,
          institutions: {} as Institution,
          registrations: [] as any[],
        },
      },
      null,
    ],
    queryFn: () => courseService.loadByStudentId(+studentId),
  })

  const courseOptions = formatOptions(courses, 'titulo')

  const [enrolled] = coursesResponse

  const enrolledCourses = enrolled?.data?.courses
  const registrations = enrolled?.data?.registrations
  const institution = (enrolled?.data?.institutions as any)?.institution

  useEffect(() => {
    filterCoursesByInstitution(+institution?.id)
  }, [filterCoursesByInstitution])

  return {
    courseOptions,
    institution,
    registrations,
    courses,
    isLoadingCourses,
    enrolledCourses,
    filterCoursesByInstitution,
  }
}
